module.exports = __webpack_public_path__ + "img/Frame-91.02f02cb3.svg";